import { formatarTempo } from '../lib/notacao';
import { Icone } from './Icone';

interface RelogioProps { nome: string; tempo: number; ativo: boolean; cor: 'w'|'b'; semRelogio: boolean; pensando?: boolean }
export function Relogio({ nome, tempo, ativo, cor, semRelogio, pensando }: RelogioProps) {
  return (
    <div className={`relogio-jogador ${ativo ? 'relogio-ativo' : ''} ${tempo < 10_000 && !semRelogio ? 'relogio-urgente' : ''}`}>
      <div className={`medalhao-cor ${cor === 'w' ? 'medalhao-claro' : 'medalhao-escuro'}`}><span /></div>
      <div className="identidade-jogador"><small>{cor === 'w' ? 'BRANCAS' : 'PRETAS'}</small><strong>{nome}</strong>{pensando && <em>analisando a posição…</em>}</div>
      <div className="mostrador-relogio"><Icone nome="relogio" tamanho={17}/><span>{semRelogio ? '—:—' : formatarTempo(tempo)}</span></div>
    </div>
  );
}
